import script from "./Drum.vue?vue&type=script&setup=true&lang=js"
export * from "./Drum.vue?vue&type=script&setup=true&lang=js"

import "./Drum.vue?vue&type=style&index=0&id=3157ce2d&lang=scss&scoped=true"

import exportComponent from "D:\\Projects\\profgame\\client\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-3157ce2d"]])

export default __exports__